var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchValue,
            expression: "searchValue",
          },
        ],
        ref: "refSearchInput",
        staticClass: "autoSearch__input",
        class: { "has-historyButton": _vm.allowBrowseHistory },
        attrs: {
          type: "search",
          autocomplete: "nope",
          maxlength: _vm.MAX_LENGTH,
          "aria-label": _vm.trans("SEARCH"),
          placeholder: _vm.trans("HOMEPAGE_SEARCHBAR_PLACEHOLDER_2016"),
          name: "searchBar",
        },
        domProps: { value: _vm.searchValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.searchValue = $event.target.value
            },
            _vm.inputChange,
          ],
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return _vm.setSearchValue.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              )
                return null
              $event.preventDefault()
              return _vm.selectUp.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown",
                ])
              )
                return null
              $event.preventDefault()
              return _vm.selectDown.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              )
                return null
              $event.preventDefault()
              return _vm.showAutocomplete(false)
            },
          ],
          focus: function ($event) {
            return _vm.showAutocomplete(true)
          },
          blur: function ($event) {
            return _vm.showAutocomplete(false)
          },
        },
      }),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showAutoBox
          ? _c(
              "div",
              {
                class: _vm.isMobile
                  ? "autocompleteList--mobile"
                  : "autocompleteList",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex__justifyContent--spaceBetween booleanSearch__box",
                  },
                  [
                    _c("p", {
                      staticClass: "booleanSearch__text",
                      domProps: {
                        innerHTML: _vm._s(_vm.trans("BOOLEAN_SEARCH_TEXT")),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "link booleanSearch__link",
                        attrs: {
                          rel: "noopener",
                          target: "_blank",
                          href: _vm.locale === "de" ? _vm.linkDE : _vm.linkEN,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.trans("BOOLEAN_SEARCH_LINK_TEXT")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.showHistory
                  ? _c(
                      "div",
                      {
                        class: _vm.isMobile
                          ? "autocompleteList__operatorInfo--mobile"
                          : "autocompleteList__operatorInfo",
                        attrs: { id: "searchOperatorInfo" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.trans("AUTO_COMPLETE__RECENT_SEARCHS")) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm.searchArray.length > 0 && _vm.showSuggestionText
                  ? _c(
                      "div",
                      {
                        class: _vm.isMobile
                          ? "autocompleteList__operatorInfo--mobile"
                          : "autocompleteList__operatorInfo",
                        attrs: { id: "searchOperatorInfo" },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.trans("AUTO_COMPLETE__SUGGESTIONS")) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showHistory
                  ? _c(
                      "ul",
                      { staticClass: "autocompleteList__resultsHistory" },
                      _vm._l(_vm.histories, function (value, key, index) {
                        return _c(
                          "li",
                          {
                            key: key,
                            staticClass: "autocompleteList__resultsItem",
                            class: {
                              "autocompleteList__item--selected":
                                index === _vm.selectedResult,
                            },
                          },
                          [
                            value.entry.q !== ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "autocomplete__history__item",
                                    class: {
                                      "autocomplete__history__item--mobile":
                                        _vm.isMobile,
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "stat__svgIcon autocompleteList__item__icon padding-right-5",
                                      },
                                      [
                                        _c("use", {
                                          attrs: { "xlink:href": "#iconClock" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "autocomplete__history__item--width",
                                        on: {
                                          mousedown: function ($event) {
                                            return _vm.selectItem(value.entry.q)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(value.entry.q) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteClickEvents(
                                              value.entryUniqueIdEncrypted
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(" delete history"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "stat__svgIcon autocompleteList__item__icon",
                                          },
                                          [
                                            _c("use", {
                                              attrs: {
                                                "xlink:href": "#iconCrossBold",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm.searchArray.length > 0
                  ? _c(
                      "ul",
                      { staticClass: "autocompleteList__results" },
                      _vm._l(_vm.searchArray, function (item, index) {
                        return _c(
                          "li",
                          {
                            key: item,
                            staticClass: "autocompleteList__resultsItem",
                            class: {
                              "autocompleteList__item--selected":
                                index === _vm.selectedResult,
                              "autocompleteList__resultsItem--mobile":
                                _vm.isMobile,
                            },
                            on: {
                              mousedown: function ($event) {
                                return _vm.selectItem(item)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "autocompleteList__resultsItem__icon",
                              },
                              [
                                _vm.isMobile
                                  ? _c(
                                      "svg",
                                      {
                                        staticClass: "text-color--gray-blue",
                                        attrs: {
                                          height: "20",
                                          width: "20",
                                          "aria-hidden": "true",
                                        },
                                      },
                                      [
                                        _c("use", {
                                          attrs: {
                                            href: "#iconMagnifyingGlassRegular",
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("a", {
                                  staticClass:
                                    "autocompleteList__item autocompleteList__item--linkReset",
                                  class: {
                                    "autocompleteList__item--mobile":
                                      _vm.isMobile,
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.highlightSearch(item, _vm.searchValue)
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "autocomplete__deleteIcon searchIcon__right",
          on: { click: _vm.clearInput },
        },
        [
          _vm.searchValue.length > 0
            ? _c(
                "svg",
                { attrs: { height: "16", width: "16", "aria-hidden": "true" } },
                [_c("use", { attrs: { href: "#iconCrossCircleBoldInverted" } })]
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }